import EmblaCarousel from 'embla-carousel';
import { addDotBtnsAndClickHandlers } from './emblacarouseldotbutton';
import { addPrevNextBtnsClickHandlers } from './emblacarouselarrowbuttons';
import Autoplay from 'embla-carousel-autoplay';

const launchEmbla = (htmlNode) => {
    const OPTIONS = { align: 'start' }
    const viewportNode = htmlNode.querySelector('.embla__viewport');
    const dotsNode = htmlNode.querySelector('.embla__dots');
    const prevBtnNode = htmlNode.querySelector('.embla__button--prev')
    const nextBtnNode = htmlNode.querySelector('.embla__button--next')

    const emblaApi = EmblaCarousel(viewportNode, OPTIONS, [Autoplay()]);

    const onNavButtonClick = (emblaApi) => {
        const autoplay = emblaApi?.plugins()?.autoplay;

        if (!autoplay) return;

        const resetOrStop = autoplay.options.stopOnInteraction === false ? autoplay.reset : autoplay.stop;

        resetOrStop();
    }

    const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(
        emblaApi,
        prevBtnNode,
        nextBtnNode,
        onNavButtonClick
    )

    const removeDotsBtnsAndClickHandlers = addDotBtnsAndClickHandlers(
        emblaApi,
        dotsNode,
        onNavButtonClick
    )

    emblaApi.on('destroy', removeDotsBtnsAndClickHandlers);
    emblaApi.on('destroy', removePrevNextBtnsClickHandlers)
}

export { launchEmbla }
